import { dateFormatter, DateFormatTypes, getDateTimeToDDMMMYYYY, sortList } from '../../../util/util'

export const sortByDate = (data: any) => {
  return sortList(data, 'createdDate', 'DESC')
}

export const convertDate = (date: string) => {
  // const dateObj = new Date(date)
  let dateWithAmPm = dateFormatter(date, DateFormatTypes.DATE_AM_PM)
  dateWithAmPm = getDateTimeToDDMMMYYYY(dateWithAmPm, false)
  // console.log('di', date, dateWithAmPm)
  return dateWithAmPm
}

export const isAnyChecked = (data: any) => {
  return data.filter((item: any) => item?.isChecked === true).length > 0
}

export const getFullName = (userData) => {
  const firstName = userData?.user?.name?.firstName
  const lastName = userData?.user?.name?.lastName
  let fullName = ''
  if (firstName) {
    fullName = fullName + firstName
  }
  if (lastName) {
    fullName = fullName + ' ' + lastName
  }
  return fullName
}

export const getProfileLabel = (userData) => {
  const firstName = userData?.user?.name?.firstName
  const lastName = userData?.user?.name?.lastName
  let fullName = ''
  if (firstName) {
    fullName = fullName + firstName?.slice(0, 1)?.toUpperCase()
  }
  if (lastName) {
    fullName = fullName + lastName?.slice(0, 1)?.toUpperCase()
  }
  return fullName
}
